module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6r9XlGQbm5V2fHXWc1wNPg-87ee6e8bf471ef2d1560dad69048301b.jpg";